## for API
Success:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true

Token:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    access_token:
      type: string
      description: 使用者検証のためのアクセストークン
      example: 123456a7b8c9d0f1e1234f567ghi89ij0kl1m2n34o5p6789q0rs1234t56u7v8
    expire:
      type: string
      description: access_tokenが満了になる日時
      example: "2021-04-04 14:05:48"
    expire_timestamp:
      type: number
      description: access_tokenが満了になるUNIX TIMESTAMEP
      example: 1617545148

FolderList:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    lists:
      type: array
      description: リストの詳細な内容
      items:
        type: object
        properties:
          dir_seq:
            type: string
            description: フォルダーの固有キー
          parent_node:
            type: string
            description: |
              フォルダーの親ノード
          node:
            type: string
            description: |
              フォルダーのノード
                - 下位ファイルを照会や操作する時使用
          name:
            type: string
            description: フォルダーの名前
          type:
            type: string
            description: |
              フォルダーの属性情報
              - **my:** MyBOX
              - **shared:** SharedBOX
            enum:
              - my
              - shared
          datetime:
            type: string
            description: フォルダーの最終情報更新日
          url:
            type: string
            description: ウェブアドレス
          drive_path:
            type: string
            description: ドライブパス
        example:
          - dir_seq: 83002
            parent_node : 1{2
            node: 1{2011
            name: Photo
            type: shared
            datetime: "2019-12-19 16:29:45"
            url: "https://web.directcloud.jp/sharedbox/MXsyVkdIVmZM"
            drive_path: "/共有/test/install"
          - dir_seq: 83003
            parent_node: 1{2
            node: 1{2012
            name: Video
            type: shared
            datetime: "2018-05-29 14:01:07"
            url: "https://web.directcloud.jp/sharedbox/MXsyVkdIcGJY"
            drive_path: "/共有/test/Documents"
          - dir_seq: 110334
            parent_node: 1{2
            node: 1{2013
            name: Contract
            type: shared
            datetime: "2020-06-12 16:56:47"
            url: "https://web.directcloud.jp/sharedbox/MXsyVkdIeWlO"
            drive_path: "/共有/test/Images"

CreateFolder:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    name:
      type: string
      description: 新しい生成されたフォルダーの名前
      example: DirectCloud
    node:
      type: string
      description: 新しい生成されたフォルダーのnode
      example: 1{2011XEA
    path:
      type: string
      description: 新しい生成されたフォルダーの経路
      example: /Shared Box/Photo/DirectCloud/

FolderInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: リストの詳細
      properties:
        dir_seq:
          type: string
          description: フォルダー固有キー
        node:
          type: string
          description: フォルダのノード
        name:
          type: string
          description: フォルダーの名前
        type:
          type: string
          description: |
            フォルダの属性情報
            - **my:** マイボックス
            - **shared:** 共有
        datetime:
          type: string
          description: フォルダの作成日時
        url:
          type: string
          description: ウェブアドレス
        drive_path:
          type: string
          description: ドライブパス
      example:
        dir_seq: 83000
        parent_node : 1{2011
        node: 1{2011XEA
        name:  DirectCloud
        type: shared
        datetime: "2021-07-21 09:54:48"
        url: "https://web.directcloud.jp/sharedbox/MXsyVkdIVmZM"
        drive_path: "/共有/test/install"

FoldersQuota:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: リストの詳細
      properties:
        used:
          type: number
          description: 使用中の容量
        quota:
          type: number
          description: 保存容量上限値
      example:
        used: 10999036
        quota: 116391936

GetFiles:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    total:
      type: number
      description: 照会したフォルダーのファイルの全体数
      example: 4
    lastpage:
      type: boolean
      description: 最終ページの有無
      example: true
    lists:
      type: array
      description: 照会中のフォルダーに存在するファイルの情報
      items:
        type: object
        properties:
          file_seq:
            type: number
            description: ファイルの固有キー
          name:
            type: string
            description: ファイルの名前
          extension:
            type: string
            description: ファイルの拡張子
          size:
            type: number
            description: ファイルのbyte容量
          creator:
            type: string
            description: ファイルをアップロードした使用者のID
          datetime:
            type: string
            description: フォルダーの最終情報更新日
          sizetext:
            type: string
            description: ファイルの容量のbyte換算数値
        example:
          - file_seq: 8982
            name: appple-release.aab
            extension: aab
            size: 24612212
            creator: user-1
            datetime: 2021-01-08 10:02:03
            sizetext: 23.47MB
          - file_seq: 5109
            name: icon.png
            extension: png
            size: 2193
            creator: user-2
            datetime: 2020-08-28 00:22:39
            sizetext: 2.14KB
          - file_seq: 5013
            name: ubuntu_main.PNG
            extension: png
            size: 304336
            creator: user-2
            datetime: 2019-03-12 17:07:54
            sizetext: 297.20KB
          - file_seq: 53207
            name: zookeepr.jpg
            extension: jpg
            size: 5005
            creator: user-1
            datetime: 2020-08-31 07:54:59
            sizetext: 4.89KB

FileInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: リストの詳細
      properties:
        file_seq:
          type: string
          description: ファイル固有キー
          example: 410711
        name:
          type: string
          description: ファイル名
          example: DirectCloudLogo.png
        extension:
          type: string
          description: ファイル拡張子
          example: png
        size:
          type: string
          description: ファイルのサイズ
          example: 8640
        creator:
          type: string
          description: ファイル所有者
          example: John Doe
        datetime:
          type: string
          description: ファイル作成日時
          example: "2021-07-21 09:54:18"
        sizetext:
          type: string
          description: ファイルのサイズbyte値
          example: 8.44KB

CompressedLinkInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    all:
      type: string
      description: 応答メッセージ
      example: ""
    download_url:
      type: string
      description: ダウンロードURL
      example: https://api.directcloud.jp/openapi/download/compress?d=JIxu%2Bx21laZuM8RM3MKzqW3Aatw8LRFQgOnU8I4sC5sbrFyv92UGgfupgFYO6lavVVwcl2UTp9g%3D%3D
    result_code:
      type: string
      description: 複数ファイルのサムネイル画像の取得 応答コード（1001:成功、4001：権限なし、4002：容量または個数の上限超過）
      example: 1001

UploadFile:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    file_seq:
      type: number
      description: ファイルの固有キー
      example: 410711
    name:
      type: string
      description: ファイルの名前
      example: DirectCloudLogo.png
    extension:
      type: string
      description: ファイルの拡張子
      example: png
    size:
      type: number
      description: ファイルの容量
      example: 8640
    sizetext:
      type: string
      description: ファイルの容量のbyte換算数値
      example: 8.44KB

DownloadFile:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    download_url:
      type: string
      description: ファイルをダウンロードできるURL
      example: http://cdntest.directcloud.jp/aaaa/bbbb/20171120090645253386?response-content-disposition=attachment%3B%20filename%3D%22test113322211.jpg%22%3B%20filename%2A%3DUTF-8%27%27test113322211.jpg&Expires=1511232423&Signature=UK7kROL6geijxThPLkZcrkG4aP9f9BN9zme5t5U1piDpDF8d6OWlf2LBZQ1gqPIQrD9wftkNa3zrjYXWSTnb0abKQbcJNRD1CEZC-jo-EMtAoDOnk9r0FCjYC2kU-ZcvHEPSyybDCFs0DUHJoj2TN-tTyHlNEFuXrdLJI~dj2CN9ykseMir7iFtBpw1qQeNQ5gQgs07S7fhATy22Plv8R-dOtNwKczP3hpzl-Y7RImX4vQijHjg5JlbMGkDwhcKIofNYM~-ggm1Q4CguPtHZRvTyWGVmGkWGh6EquIkWqG-9U4l6B9G0Z7fOknKpvOmd3JQcr2N2Lu0696CKbBvsVA__&Key-Pair-Id=APKAJV43NA6KHFLMBOQQ

SearchFile:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    total:
      type: number
      description: 検索したファイルの全体数
      example: 17
    lastpage:
      type: boolean
      description: 最終ページがあるかどうか
      example: true
    lists:
      type: array
      description: 照会中のフォルダーに存在するファイルの情報
      items:
        type: object
        properties:
          file_seq:
            type: number
            description: ファイルの固有キー
          name:
            type: string
            description: ファイルの名前
          extension:
            type: string
            description: ファイルの拡張子
          size:
            type: number
            description: ファイルの容量
          creator:
            type: string
            description: ファイルをアップロードした使用者のID
          datetime:
            type: string
            description: フォルダーの最終情報更新日
          node:
            type: string
            description: ファイルのあるnode
          sizetext:
            type: string
            description: ファイルの容量のbyte換算数値
          path:
            type: string
            description: ファイルがあるフォルダーの経路
      example:
        - file_seq: 40123
          name: HowToUseDirectCloudBoxProperly.pdf
          extension: pdf
          size: 4621338
          creator: Irene
          datetime: 2021-01-27 10:13:07
          node: 1{2co3
          sizetext: 4.41MB
          path: /Shared Box/Instruction/
        - file_seq: 40994
          name: MountainView.txt
          extension: txt
          size: 20
          creator: Kone
          datetime: 2021-01-11 21:32:50
          node: 1{200BiDu
          sizetext: 20.00B
          path: /Shared Box/Kone/editor-/
        - file_seq: 34649
          name: Dinner.png
          extension: png
          size: 245204
          creator: Yulius
          datetime: 2020-09-16 15:12:42
          node: 1{2x3z4Y5
          sizetext: 239.46KB
          path: /Shared Box/Yulius/downloader/

CreateLink:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    url:
      type: string
      description: 生成されたリンクのアドレス
      example: https://link.directcloud.jp/DabCDEF012

ViewerLink:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    url:
      type: string
      description: 生成されたビューアーのアドレス
      example: https://api.directcloud.jp/openapi/viewer/iframe/15a3e00b-ab77-45f0-bd51-e8d221a12bfb


## for Admin API
ServiceKey:
  properties:
    success:
      type: boolean
      description:
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        service:
          type: string
          description:
          example: "directcloud"
        service_key:
          type: string
          description:
          example: "1234567XXXXXXXXXX8910XXXXXXXXXX123456789XXXXXXXXXX1234567890"
    message:
      type: string
      description: 結果メッセージ
      example: ""

ServiceKeyAll:
  properties:
    success:
      type: boolean
      description:
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        user:
          type: object
          description: ユーザーのサービスキー情報
          properties:
            service:
              type: string
              example: "directcloud"
            service_key:
              type: string
              example: "1234567XXXXXXXXXX8910XXXXXXXXXX123456789XXXXXXXXXX1234567890"
            regdate:
              type: string
              format: date-time
              example: "2021-04-14 02:56:03"
        manager:
          type: object
          description: 管理者のサービスキー情報
          properties:
            service:
              type: string
              example: "directcloud_manager"
            service_key:
              type: string
              example: "1234567XXXXXXXXXX8910XXXXXXXXXX123456789XXXXXXXXXX1234567890"
            regdate:
              type: string
              format: date-time
              example: "2021-03-29 00:45:00"
    message:
      type: string
      description: 結果メッセージ
      example: ""

CompanyList:
  properties:
    success:
      type: boolean
      description: API処理結果
    result:
      type: object
      description: 結果データ
      properties:
        count:
          type: string
          description: 会社数
        lists:
          type: array
          description: 会社リスト
          items:
            type: object
            properties:
              item_code:
                type: string
                description: 締結契約
              company_seq:
                type: string
                description: 会社固有キー
              code:
                type: string
                description: 会社コード(グループアイディー)
              name:
                type: string
                description: 会社名
              country_code:
                type: string
                description: 国家コード
              regdate:
                type: string
                description: 会社登録日
              volume_size:
                type: string
                description: 割当容量(Byte)
              license_amount:
                type: string
                description: ユーザー制限数
              unlimited_license:
                type: string
                description: ユーザー無制限可否
              status:
                type: string
                description: |
                  常態
                  0 : 認証しない場合
                  10 : 無料
                  11 : 有料
                  41 : 使用停止
                  91 : 削除
                  92 : 脱退
                enum:
                  - 0
                  - 10
                  - 11
                  - 41
                  - 91
                  - 92
              end_date:
                type: string
                description: 終了日
              gmt:
                type: string
                description: 時間帯 (GMT+9)
              admin_seq:
                type: string
                description: 契約担当者固有キー
              user_count:
                type: string
                description: 登録ユーザー数
              role_name:
                type: string
                description: リセラーの権限
              reseller_name:
                type: string
                description: リセラー名(存在しない場合はnull)
              storage_usage:
                type: string
                description: 詳細使用量(Byte)
              use_trial:
                type: string
                description: 体験版の可否
              used_size:
                type: number
                description: 総使用量(Byte)
    message:
      type: string
      description: エラーメッセージ
  example:
    success: true
    result:
      count: "1990"
      lists:
        - item_code: Enterprise
          company_seq: "12305"
          code: directloud
          name: DirectCloud
          country_code: jpn
          regdate: "2021-03-02 09:19:03"
          volume_size: "32985348833280"
          license_amount: "100"
          unlimited_license: Y
          status: "10"
          end_date: "9999-12-31 00:00:00"
          gmt: " +9" # TODO: 앞에 공백 없이 + 를 나타내는 법.
          admin_seq: "20"
          user_count: "1"
          role_name: master
          reseller_name: null
          storage_usage: "{\"user\":2,\"mybox\":0,\"mybox_versioning\":0,\"trash\":0,\"company_trash\":0,\"sharedbox\":0,\"sharedbox_versioning\":0,\"talk\":0,\"post\":0,\"sharedBoxCnt\":0,\"totalVolume\":10737418240,\"totalUsage\":0,\"updated\":\"2021-03-02 23:43:27\"}"
          use_trial: N
          used_size: 0
        - item_code: Advanced
          company_seq: "23416"
          code: google-kr
          name: Google
          country_code: kor
          regdate: "2021-08-18 02:41:24"
          volume_size: "536870912000"
          license_amount: "0"
          unlimited_license: Y
          status: "11"
          end_date: "9999-12-31 00:00:00"
          gmt: " +9" # TODO: 앞에 공백 없이 + 를 나타내는 법.
          admin_seq: "1"
          user_count: "3000"
          role_name: master
          reseller_name: null
          storage_usage: "{\"user\":1,\"mybox\":0,\"mybox_versioning\":0,\"trash\":0,\"company_trash\":0,\"sharedbox\":0,\"sharedbox_versioning\":0,\"talk\":0,\"post\":0,\"sharedBoxCnt\":0,\"totalVolume\":536870912000,\"totalUsage\":0,\"updated\":\"2021-08-19 23:01:17\"}"
          use_trial: N
          used_size: 0
    message: ""

CompanyCreate:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: string
      description: 結果
      example: ""
    message:
      type: string
      description: 結果メッセージ
      example: Successfully registered.

CompanyModify:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: string
      description: 結果データ
      example: ""
    message:
      type: string
      description: 結果メッセージ
      example: Successfully edited.

CompanyDetailInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
    result:
      type: object
      description: 会社詳細情報
      properties:
        company:
          type: object
          description: 会社関連情報
          properties:
            company_seq:
              type: string
              description: 会社固有キー
            code:
              type: string
              description: 会社コード (グループID)
            name:
              type: string
              description: 会社名
            post_no:
              type: string
              description: 郵便番号
            address:
              type: string
              description: 住所
            scale:
              type: string
              description: 会社規模
            country_code:
              type: string
              description: 国家コード
            gmt:
              type: string
              description: GMT(Grennwich Mean Time) 情報
            admin_seq:
              type: number
              description: リセラー固有キー
            regdate:
              type: string
              description: 登録日
            email:
              type: string
              description: メール
            phone:
              type: string
              description: 電話番号
            access_path:
              type: string
              description: 認知経路
            item_code:
              type: string
              description: 締結契約コード
            use_trial:
              type: string
              description: Trial使用有無(boxadmin)
              enum:
                - Y
                - N
            start_date:
              type: string
              format: date
              description: 使用開始日
            end_date:
              type: string
              format: date
              description: 使用終了日
            use_campaign:
              type: string
              description: キャンペーン使用可否
              enum:
                - Y
                - N
            campaign_end_date:
              type: string
              description: キャンペーン終了日
            status:
              type: string
              description: |
                常態
                11 : 正常
                41 : 使用停止
                51 : ロック
                91 : 削除
                92 : 脱退
                その他:認証しない場合
            payment_type:
              type: string
              description: 支払方法
            flag_sending_mail:
              type: string
              description: アカウント登録時通知メール
              enum:
                - Y
                - N
            volume_size:
              type: string
              description: 容量(Byte)
            file_size:
              type: string
              description: 使用されたファイル容量
            limit_traffic:
              type: string
              description: トラフィック(Byte)
            max_upload_size:
              type: string
              description: 最大でアップロード可能なサイズ(Byte)
            max_preview_size:
              type: string
              description: 文書プレビュー可能な最大サイズ(Byte)
            max_media_preview_size:
              type: string
              description: メディアプレビュー可能な最大サイズ(Byte)
            license_amount:
              type: string
              description: ユーザー制限
            user_count:
              type: string
              description: 登録ユーザー数
            use_my_desktop:
              type: string
              description: My Desktopを使用可否
              enum:
                - Y
                - N
            use_my_box:
              type: string
              description: My Box使用の可否
              enum:
                - Y
                - N
            use_shared_box:
              type: string
              description: Shared Box使用の可否
              enum:
                - Y
                - N
            use_tag:
              type: string
              description: タグ機能の使用可否
              enum:
                - Y
                - N
            use_available_comment:
              type: string
              description: ファイル別コメント使用可否
              enum:
                - Y
                - N
            use_available_guest_invite:
              type: string
              description: Guest招待使用可否
            flag_quota_limit:
              type:
              description: Shared Box容量制限/自動削除の使用可否
              enum:
                - Y
                - N
            flag_uploadrequest:
              type: string
              description: アップロードリクエストの使用可否
              enum:
                - Y
                - N
            use_available_otp:
              type: string
              description: OTP使用可否（admin）
              enum:
                - Y
                - N
            use_available_offline:
              type: string
              description: モバイルオフライン使用可否
              enum:
                - Y
                - N
            use_zipmail:
              type: string
              description: ファイル添付メール送信の使用可否
              enum:
                - Y
                - N
            use_available_domain:
              type: string
              description: 会社別サブドメイン使用可否
              enum:
                - Y
                - N
                - C
                - D
            use_available_wf:
              type: string
              description: ワークフロー使用可否
              enum:
                - Y
                - N
            use_available_smtp:
              type: string
              description: 会社別メール送信サーバー使用可否
              enum:
                - Y
                - N
            use_session_log:
              type: string
              description: セッション履歴の使用可否
              enum:
                - Y
                - N
            use_available_file_permission:
              type: string
              description: ファイルロックの使用可否
              enum:
                - Y
                - N
            use_available_gdpr:
              type: string
              description: ユーザー同意機能の使用可否
              enum:
                - Y
                - N
            use_two_factor_sms:
              type: string
              description: 2段階認証(SMS)使用可否
              enum:
                - Y
                - N
            use_upload_alarm_one_term:
              type: string
              description: 通知メール1分ごとに通知使用可否
              enum:
                - Y
                - N
            use_available_link_default:
              type: string
              description: リンク初期値オプション高度化使用可否
              enum:
                - Y
                - N
            use_available_upload_alarm_custom:
              type: string
              description: 新規ファイルアップロード通知メールカスタム
              enum:
                - Y
                - N
            use_available_audit:
              type: string
              description: 監査エディション
              enum:
                - Y
                - N
            use_finder:
              type: string
              description: 全文検索の使用可否
              enum:
                - Y
                - N
            use_permission_bulk_upload:
              type: string
              description: 共有者一括登録の使用可否
              enum:
                - Y
                - N
            use_available_versioning:
              type: string
              description: ファイルバージョンの使用可否
              enum:
                - Y
                - N
            available_versioning_limit:
              type: string
              description: ファイルバージョン数
            use_trash:
              type: string
              description: ゴミ箱の使用可否
              enum:
                - Y
                - N
              default: Y
            trash_expiration_type:
              type: string
              description: |
                ゴミ箱削除期間
                0 : 基本
                1 : 無制限
              enum:
                - 0
                - 1
            use_company_trash:
              type: string
              description: 会社のゴミ箱の使用可否
              enum:
                - Y
                - N
              default: N
            company_trash_expiration_type:
              type: string
              description: |
                会社ゴミ箱削除期間
                0 : 最大3日
                1 : 最大無制限
                30 : 最大30日
            use_security:
              type: string
              description: 企業セキュリティ使用可否
              enum:
                - Y
                - N
            use_available_ldap:
              type: string
              description: SSO管理の使用可否
              enum:
                - Y
                - N
            sso_item:
              type: string
              description: SSO管理Item(all, GSuite&Sateraito)
              enum:
                - all
                - lite
            use_manager_log:
              type: string
              description: 管理者ログの使用可否
              enum:
                - Y
                - N
            use_available_drive:
              type: string
              description: PCドライブの使用可否
              enum:
                - Y
                - N
            viewer:
              type: string
              description: |
                使用中のビューアータイプ
                - onlyoffice
                - prizmdoc
                - vidoc
            log_db_type:
              type: string
              description: ログDB種類（RDS、ES）
            use_available_master:
              type: string
              description: Shared Box副管理者の使用可否
              enum:
                - Y
                - N
            use_available_master_start_date:
              type: string
              description: Shared Box副管理者使用開始日
            use_available_master_end_date:
              type: string
              description: Shared Box副管理者権限使用終了日
            use_available_master_user_count:
              type: string
              description: Shared Box副管理者最大数
            use_available_master_permission_detail:
              type: string
              description: Shared Box副管理者詳細設定
              enum:
                - Y
                - N
            use_available_editor:
              type: string
              description: オンライン編集の使用可否
              enum:
                - Y
                - N
            use_available_editor_start_date:
              type: string
              description: オンライン編集の使用開始日付
            use_available_editor_end_date:
              type: string
              description: オンライン編集の使用終了日付
            use_available_api_key:
              type: string
              description: OpenAPI使用の可否
              enum:
                - Y
                - N
            use_available_api_key_limit:
              type: number
              description: OpenAPI Request制限値
            use_available_api_key_start_date:
              type: string
              description: OpenAPI使用開始日付
            use_available_api_key_end_date:
              type: string
              description:  OpenAPI使用終了日付
            use_available_custom_domain:
              type: string
              description: 会社別の独立ドメイン使用可否
            use_available_ocr:
              type: string
              description: AI OCR使用の可否
              enum:
                - Y
                - N
            use_available_ocr_start_date:
              type: string
              description: OCR使用開始日付
            use_available_ocr_end_date:
              type: string
              description: OCR編集の使用終了日付
            use_dashboard:
              type: string
              description: ダッシュボード使用可否
              enum:
                - Y
                - N
            use_dashboard_extension:
              type: string
              description: ダッシュボード(VISIBLE) 詳細使用可否
              enum:
                - Y
                - N
            use_dashboard_start_date:
              type: string
              description: ダッシュボード(VISIBLE)詳細使用開始日付
            use_dashboard_end_date:
              type: string
              description: ダッシュボード(VISIBLE)詳細使用終了日付
            use_available_shield:
              type: string
              description: SHIELD使用の可否(Boxadmin)
              enum:
                - Y
                - N
            use_available_shield_extension:
              type: string
              description: Shield正式版の使用可否
              enum:
                - Y
                - N
            use_available_shield_user_count:
              type: string
              description: Shieldユーザー数
            use_available_shield_start_date:
              type: string
              description: Shield使用開始日付
            use_available_shield_end_date:
              type: string
              description: Shield使用終了日付
            use_available_fax:
              type: string
              description: FAX連携サービスの使用可否
              enum:
                - Y
                - N
            fax_vendor_code:
              type: string
              description: FAX連携サービスのvendor code
            use_available_connect:
              type: string
              description: Connect使用可否
              enum:
                - Y
                - N
            use_available_connect_start_date:
              type: string
              description: Connect使用開始日
            use_available_connect_end_date:
              type: string
              description: Connect使用終了日
            use_available_connect_limit:
              type: number
              description: Connectフォルダ1階層生成制限数
            use_available_salesforce:
              type: string
              description: Salesforce連携使用の可否
              enum:
                - Y
                - N
            use_available_salesforce_start_date:
              type: string
              description: Salesforce連携使用開始日
            use_available_salesforce_end_date:
              type: string
              description: Salesforce連携使用終了日
            use_available_web_chat:
              type: string
              description: TALK+使用可否
              enum:
                - Y
                - N
            use_available_web_chat_start_date:
              type: string
              description: TALK+使用開始日
            use_available_web_chat_end_date:
              type: string
              description: TALK+使用終了日
            use_talk:
              type: string
              description: Talk使用可否
              enum:
                - Y
                - N
            comment:
              type: string
              description: メモ
        user:
          type: object
          description: 契約担当者関連情報
          properties:
            user_seq:
              type: string
              description: ユーザー固有番号
            id:
              type: string
              description: ユーザーID
            name:
              type: string
              description: ユーザー名
              example: John Doe
            email:
              type: string
              description: ユーザーメール
            phone:
              type: string
              description: ユーザー電話番号
        reseller:
          type: object
          description: リセラーに関する情報
          properties:
            role_name:
              type: string
              description: リセラー顕現情報
            name:
              type: string
              description: リセラー名 (存在しない場合、null)
        talk:
          type: object
          description: TALK関連情報
          properties:
            talk_user_count:
                type: string
                description: TALKユーザー数
            talk_custom_field01:
                type: string
                description: TALKログ保管日
            talk_start_date:
                type: string
                description: TALK開始日
            talk_end_date:
                type: string
                description: TALK終了日
        dr:
          type: object
          description: 災害対策・遠隔地バックアップ情報
          properties:
            dr_date:
              type: string
              description: 災害復旧の日付
            dr_hour:
              type: string
              description: 災害復旧時間
            dr_minute:
              type: string
              description: 災害復旧分
            dr_memo:
              type: string
              description: メモ
            status:
              type: string
              description: |
                상태
                - **0**: 待機
                - **1**: 処理中
                - **3**: 成功
                - **9**: 失敗
        api_key:
          type: object
          description: API Key 情報
          properties:
            user:
              type: object
              description: user API Key情報(存在しない場合、empty)
              properties:
                service:
                  type: string
                  description: service名
                service_key:
                  type: string
                  description: service key
                regdate:
                  type: string
                  description: user API Key発行日
            manager:
              type: object
              description: manager API Key情報(存在しない場合、empty)
              properties:
                service:
                  type: string
                  description: service名
                service_key:
                  type: string
                  description: service key
                regdate:
                  type: string
                  description: manager API Key発行日
    message:
      type: string
      description: エラーメッセージ
  example:
    success: true
    result:
      company:
        company_seq: "12305"
        code: directcloud-jp
        name: 株式会社ダイレクトクラウド
        post_no: 105-0021
        address: 日本、〒105-0021 東京都港区東新橋２丁目１２−１
        scale: 1 - 50名
        country_code: jpn
        gmt: " +9"
        admin_seq: "54321"
        regdate: "2021-03-04 07:58:45"
        email: support@directcloud.co.jp
        phone: 03-4405-3668
        access_path: パートナーからの紹介
        item_code: Business
        use_trial: Y
        start_date: '2021-03-04'
        end_date: "2021-04-03"
        use_campaign: N
        campaign_end_date: ""
        status: "10"
        payment_type: monthly
        flag_sending_mail: Y
        volume_size: "10737418240"
        file_size: "3992"
        limit_traffic: "10737418240"
        max_upload_size: "10737418240"
        max_preview_size: "104857600"
        max_media_preview_size: "524288000"
        license_amount: "0"
        user_count: "300"
        csv_upload_limit: 5000
        use_my_desktop: N
        use_my_box: Y
        use_shared_box: Y
        use_tag: Y
        use_available_comment: Y
        use_available_guest_invite: Y
        flag_quota_limit: Y
        flag_uploadrequest: Y
        use_available_otp: Y
        use_available_offline: Y
        use_zipmail: Y
        use_available_domain: N
        use_available_wf: Y
        use_available_smtp: Y
        use_session_log: N
        use_available_file_permission: Y
        use_available_gdpr: N
        use_two_factor_sms: Y
        use_upload_alarm_one_term: Y
        use_available_link_default: N
        use_available_upload_alarm_custom: N
        use_available_audit: N
        use_finder: Y
        use_permission_bulk_upload: Y
        use_available_versioning: Y
        available_versioning_limit: "30"
        use_trash: Y
        trash_expiration_type: "1"
        use_company_trash: Y
        company_trash_expiration_type: "30"
        use_security: Y
        use_available_ldap: Y
        sso_item: all
        use_manager_log: Y
        use_available_drive: Y
        viewer: onlyoffice
        log_db_type: ES
        use_available_master: N
        use_available_master_start_date: "2021-03-04"
        use_available_master_end_date: "2021-04-03"
        use_available_master_user_count: "5"
        use_available_master_permission_detail: Y
        use_available_editor: Y
        use_available_editor_start_date: "2021-03-04"
        use_available_editor_end_date: "2021-04-03"
        use_available_api_key: Y
        use_available_api_key_limit: 10000
        use_available_api_key_start_date: "2021-03-04"
        use_available_api_key_end_date: "2021-04-03"
        use_available_custom_domain: Y
        use_available_ocr: Y
        use_available_ocr_start_date: "2021-03-04"
        use_available_ocr_end_date: "2021-04-03"
        use_dashboard: Y
        use_dashboard_extension: N
        use_dashboard_start_date: "2021-03-04"
        use_dashboard_end_date: "2021-04-03"
        use_available_shield: Y
        use_available_shield_extension: N
        use_available_shield_user_count: "10"
        use_available_shield_start_date: "2021-03-04"
        use_available_shield_end_date: "2021-04-03"
        use_available_fax: Y
        fax_vendor_code: "NTTCW"
        use_available_connect: Y
        use_available_connect_start_date: "2021-03-04"
        use_available_connect_end_date: "2021-04-03"
        use_available_connect_limit: 1000
        use_available_salesforce: Y
        use_available_salesforce_start_date: "2021-03-04"
        use_available_salesforce_end_date: "2021-04-03"
        use_available_web_chat: Y
        use_available_web_chat_start_date: "2021-03-04"
        use_available_web_chat_end_date: "2021-04-03"
        use_talk: Y
        comment: ""
      user:
        user_seq: "345678"
        id: dc-master
        name: John Doe
        email: master@directcloud.co.jp
        phone: 123-4567-8910
      reseller:
        role_name: master
        name: DirectCloud
      talk:
        talk_user_count: "50"
        talk_custom_field01: "365"
        talk_start_date: "2021-03-04"
        talk_end_date: "2021-04-03"
      dr:
        dr_date: "2020-05-20"
        dr_hour: "00"
        dr_minute: "00"
        dr_memo: "OSAKA Noon"
        status: "3"
      api_key:
        user:
          service: "directcloud-jp"
          service_key: "abcdefghijk12345678"
          regdate: "2021-03-04 15:00:00"
        manager:
          service: "directcloud-jp_manager"
          service_key: "12345678abcdefghijk"
          regdate: "2021-03-04 15:00:00"
    message: ""

CompanyCodeModify:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: string
      description: 結果データ
      example: ""
    message:
      type: string
      description: 結果メッセージ
      example: ""

ResellerList:
  properties:
    success:
      type: boolean
      description: API処理結果
    result:
      type: object
      description: 結果データ
      properties:
        count:
          type: string
          description: 会社数
        lists:
          type: array
          description: 会社リスト
          items:
            type: object
            properties:
              admin_seq:
                type: string
                description: リセラー固有キー
              country_code:
                type: string
                description: 国家コード
              name:
                type: string
                description: 名前
              id:
                type: string
                description: ID
              contact_name:
                type: string
                description: 担当者の名前
              phone:
                type: string
                description: 電話番号
              email:
                type: string
                description: メール
              status:
                type: number
                description: |
                  상태  
                  - **11**: 正常
                  - **41**: 使用停止
                  - **51**: ロック
                  - **91**: 削除
                  - **92**: 脱退
                  - **その他**: 認証しない場合
              no_pay_count:
                type: number
                description: 無料契約数
              pay_count:
                type: number
                description: 有料契約数
              regdate:
                type: string
                description: 登録日
    message:
      type: string
      description: エラーメッセージ
      example: ""
  example:
    success: true
    result:
      count: 1990
      example:
        - admin_seq: 30
          country_code: jpn
          name: 株式会社サテライトオフィス
          id: SateraitoOffice
          contact_name: John
          phone: "03-4123-4567"
          email: john@sateraito.co.jp
          status: 11
          no_pay_count: 0
          pay_count: 1
          regdate: "2020-06-05 04:03:21"
        - admin_seq: 29
          country_code: eng
          name: Google
          id: google-usa
          contact_name: Jane
          phone: "415-555-6666"
          email: jane@gmail.com
          status: 11
          no_pay_count: 0
          pay_count: 1
          regdate: "2020-05-05 05:02:10"
    message: ""

ResellerDetailInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
    result:
      type: object
      description: 結果データ
      properties:
        admin_seq:
          type: number
          description: リセラー固有キー
        role_name:
          type: string
          description: 権限
        name:
          type: string
          description: 名前
        id:
          type: string
          description: ID
        country_code:
          type: string
          description: 国家コード
        contact_name:
          type: string
          description: 担当者の名前
        phone:
          type: string
          description: 電話番号
        email:
          type: string
          description: メール
        logo_img_url:
          type: string
          description: ロゴ画像URL
        mobile_logo_img_url:
          type: string
          description: モバイルロゴ画像URL
        status:
          type: number
          description: |
            状態
              - **11**: 正常
              - **41**: 使用停止
              - **51**: ロック
              - **91**: 削除
              - **92**: 脱退
              - **その他**: 認証しない場合
        regdate:
          type: string
          description: 登録日
        login_datetime:
          type: string
          description: 最終ログイン時間
        comment:
          type: string
          description: メモ
    message:
      type: string
      description: エラーメッセージ
  example:
    success: true
    result:
      admin_seq: 30
      role_name: reseller
      name: 株式会社サテライトオフィス
      id: SateraitoOffice
      country_code: jpn
      contact_name: John
      phone: "03-4123-4567"
      email: john@sateraito.co.jp
      logo_img_url: "https://s3-bucket-region.amazonaws.com/bucket-name/dir-name/20201209092833200004_logo"
      mobile_logo_img_url: "https://s3-bucket-region.amazonaws.com/bucket-name/dir-name/2020120909283325_logo"
      status: 11
      regdate: "2019-01-20 01:29:31"
      login_datetime: "2021-01-02 03:04:56"
      comment: "hello DirectCloud"
    message: ""

ItemDetailInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
    result:
      type: object
      description: 結果データ
      properties:
        use_my_desktop:
          type: string
          description: My Desktop使用の可否
        use_my_box:
          type: string
          description: My Box使用の可否
        use_shared_box:
          type: string
          description: Shared Box使用の可否
        use_tag:
          type: string
          description: タグ機能の使用可否
        use_available_comment:
          type: string
          description: ファイル別コメント使用可否
        use_available_guest_invite:
          type: string
          description: Guest招待使用可否
        flag_quota_limit:
          type: string
          description: Shared Box容量制限/自動削除の使用可否
        use_available_master:
          type: string
          description: Shared Box副管理者権限使用可否
        use_available_master_user_count:
          type: string
          description: Shared Box副管理者最大数
        use_available_master_permission_detail:
          type: string
          description: Shared Box副管理者権限詳細設定
        flag_uploadrequest:
          type: string
          description: アップロードリクエストの使用可否
        use_available_otp:
          type: string
          description: 2段階認証(email)の使用可否
        use_available_offline:
          type: string
          description: モバイルオフライン使用可否
        use_zipmail:
          type: string
          description: ファイル添付メール送信の使用可否
        use_available_domain:
          type: string
          description: 会社別サブドメイン使用可否
        use_available_custom_domain:
          type: string
          description: 会社別独立ドメイン使用可否
        use_available_wf:
          type: string
          description: ワークフロー使用可否
        use_available_smtp:
          type: string
          description: 会社別メール送信サーバー使用可否
        use_session_log:
          type: string
          description: セッション履歴の使用可否
        use_available_file_permission:
          type: string
          description: ファイルロックの使用可否
        use_available_gdpr:
          type: string
          description: ユーザー同意機能の使用可否
        use_two_factor_sms:
          type: string
          description: 2段階認証(SMS)使用可否
        use_upload_alarm_one_term:
          type: string
          description: 통지메일 1분마다 알림 사용 여부
        use_available_link_default:
          type: string
          description: 링크 초기값 옵션 고도화 사용 여부
        use_available_upload_alarm_custom:
          type: string
          description: 신규파일 업로드 알림 메일 커스텀
        use_available_audit:
          type: string
          description: 감사 에디션
        use_finder:
          type: string
          description: 全文検索の使用可否
        use_available_editor:
          type: string
          description: オンライン編集の使用可否
        use_dashboard:
          type: string
          description: ダッシュボード使用可否
        use_dashboard_extension:
          type: string
          description: ダッシュボード詳細使用可否
        use_permission_bulk_upload:
          type: string
          description: 共有者一括登録の使用可否
        use_available_versioning:
          type: string
          description: ファイルバージョンの使用可否
        available_versioning_limit:
          type: string
          description: ファイルバージョン数
        use_available_trash:
          type: string
          description: ユーザーゴミ箱の使用可否
        trash_expiration_type:
          type: string
          description: ユーザーゴミ箱保管期間
        use_company_trash:
          type: string
          description: 会社のゴミ箱の使用可否
        company_trash_expiration_type:
          type: string
          description: 会社ゴミ箱保管期間
        use_security:
          type: string
          description: 企業セキュリティ使用可否
        use_available_ldap:
          type: string
          description: SSO管理の使用可否
        sso_item:
          type: string
          description: SSO管理Item(all, GSuite&Sateraito)
        use_available_shield:
          type: string
          description: Shieldを使用可否
        use_available_shield_extension:
          type: string
          description: Shield正式版の使用可否
        use_available_shield_user_count:
          type: string
          description: Shieldユーザー数
        use_available_ocr:
          type: string
          description: AI OCRの使用可否
        use_available_api_key:
          type: string
          description: OpenAPI使用可否
        use_available_api_key_limit:
          type: string
          description: OpenAPI Request制限値
        use_available_fax:
          type: string
          description: FAX連携使用の可否
        fax_vendor_code:
          type: string
          description: FAX Vendor Code
        use_available_connect:
          type: string
          description: Connect使用可否
        use_available_connect_limit:
          type: string
          description: Connectフォルダ1階層生成制限数
        use_available_salesforce:
          type: string
          description: Salesforce使用可否
        use_available_web_chat:
          type: string
          description: TALK+使用可否
        use_manager_log:
          type: string
          description: 管理者ログの使用可否
        use_available_drive:
          type: string
          description: PC Drive使用可否
        viewer:
          type: string
          description: 使用するビューア情報
        log_db_type:
          type: string
          description: Logデータベースの使用可否
        volume_size:
          type: number
          description: 容量(Byte)
        traffic:
          type: number
          description: トラフィック(Byte)
        max_upload_size:
          type: number
          description: 最大でアップロード可能なサイズ(Byte)
        max_preview_size:
          type: number
          description: 文書プレビュー可能な最大サイズ(Byte)
        max_media_preview_size:
          type: number
          description: メディアプレビュー可能な最大サイズ(Byte)
        license_amount:
          type: number
          description: ユーザー制限
        csv_upload_limit:
          type: number
          description: CSV一括登録アップロード行数制限
        status:
          type: string
          description: 常態
        talk_user_count:
          type: number
          description: Talkを使用するユーザー数
        talk_custom_field01:
          type: number
          description: Talkログ保管日
    message:
      type: string
      description: エラーメッセージ
  example:
    success: true
    result:
      use_my_desktop: N
      use_my_box: Y
      use_shared_box: Y
      use_tag: Y
      use_available_comment: Y
      use_available_guest_invite: Y
      flag_quota_limit: Y
      use_available_master: N
      use_available_master_user_count: "3"
      use_available_master_permission_detail: Y
      flag_uploadrequest: Y
      use_available_otp: Y
      use_available_offline: Y
      use_zipmail: Y
      use_available_domain: N
      use_available_custom_domain: N
      use_available_wf: Y
      use_available_smtp: Y
      use_session_log: N
      use_available_file_permission: Y
      use_available_gdpr: N
      use_two_factor_sms: Y
      use_upload_alarm_one_term: Y
      use_available_link_default: N
      use_available_upload_alarm_custom: N
      use_available_audit: N
      use_finder: Y
      use_available_editor: Y
      use_dashboard: Y
      use_dashboard_extension: Y
      use_permission_bulk_upload: Y
      use_available_versioning: Y
      available_versioning_limit: "100"
      use_available_trash: Y
      trash_expiration_type: "1"
      use_company_trash: Y
      company_trash_expiration_type: "1"
      use_security: Y
      use_available_ldap: Y
      sso_item: "all"
      use_available_shield: Y
      use_available_shield_extension: Y
      use_available_shield_user_count: "50"
      use_available_ocr: Y
      use_available_api_key: Y
      use_available_api_key_limit: "10000"
      use_available_fax: Y
      fax_vendor_code: "VENDORCODE"
      use_available_connect: Y
      use_available_connect_limit: 1000
      use_available_salesforce: Y
      use_available_web_chat: Y
      use_manager_log: Y
      use_available_drive: Y
      viewer: "onlyoffice"
      log_db_type: "ES"
      volume_size: 10737418240
      traffic: 10737418240
      max_upload_size: 10737418240
      max_preview_size: 314572800
      max_media_preview_size: 1073741824
      license_amount: 0
      csv_upload_limit: "3000"
      status: "10"
      talk_user_count: 50
      talk_custom_field01: 365
    message: ""

NoticeList:
  properties:
    success:
      type: boolean
      description: API処理結果
    result:
      type: object
      description: 結果データ
      properties:
        count:
          type: number
          description: お知らせ数
        lists:
          type: array
          description: お知らせリスト
          items:
            type: object
            properties:
              notice_seq:
                type: number
                description: お知らせ固有キー
              admin_seq:
                type: number
                description: お知らせを作成した管理者のadmin_seq
              category:
                type: string
                description: |
                  区分
                    - **NOTICE**: お知らせ
                    - **UPDATE**: アップデート
                    - **ISSUE**: 障害情報
                    - **CORRECT**: その他
                example: NOTICE
              title:
                type: string
                description: 題目
              hits:
                type: number
                description: 照会数
              status:
                type: string
                description: |
                  公開の可否
                    - **0**: 非公開
                    - **1**: 公開
              created:
                type: string
                description: 作成時間
    message:
      type: string
      description: エラーメッセージ
      example: ""
  example:
    success: true
    result:
      count: 80
      lists:
        - notice_seq: 11
          admin_seq: 4321
          category: UPDATE
          title: 2019 Q3 Update
          hits: 52
          status: 1
          created: "2019-08-20 16:50:08"
        - notice_seq: 20
          admin_seq: 4321
          category: NOTICE
          title: サービスアップデートのお知らせ
          hits: 145
          status: 1
          created: "2020-01-01 12:00:00"
      message: ""

NoticeDetailInfo:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        notice_seq:
          type: string
          description: お知らせ固有キー
        admin_seq:
          type: string
          description: お知らせを作成した管理者admin_seq
        category:
          type: string
          description: |
            区分
              - **NOTICE**: お知らせ
              - **UPDATE**: アップデート
              - **ISSUE**: 障害情報
              - **CORRECT**: その他
        title:
          type: string
          description: 題目
        content:
          type: string
          description: 内容
        hits:
          type: string
          description: 照会数
        status:
          type: string
          description: |
            公開の可否
              - **0**: 非公開
              - **1**: 公開
        created:
          type: string
          description: 作成時間
    message:
      type: string
      description: エラーメッセージ
  example:
    success: true
    result:
      notice_seq: 11
      admin_seq: 4321
      category: UPDATE
      title: 2019 Q3 Update
      content: "Year 2019 3rd Q Update"
      hits: 52
      status: 1
      created: "2019-08-20 16:50:08"
    message: ""


## for Manager API
UserList:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    total:
      type: number
      description: 総使用者数
      example: 2
    lists:
      type: object
      description: 結果データ
      properties:
        user_seq:
          type: number
          decription: ユーザー固有番号
        role_name:
          type: string
          decription: ユーザーロール
        id:
          type: string
          decription: ユーザーID
        name:
          type: string
          decription: ユーザー名
        email:
          type: string
          description: ユーザーメールアドレス
        lang:
          type: string
          description: ユーザー言語
        phone:
          type: string
          decription: ユーザーの電話番号
        status:
          type: number
          decription: ユーザー登録状態
        regdate:
          type: string
          decription: ユーザー登録日時
      example:
        - user_seq: 1
          role_name: MANAGER
          id: dc.john.doe
          name: John Doe
          email: dc.johndoe@directcloud.com
          lang: jpn
          phone: 0123456789
          status: 11
          regdate: "2021-03-28 23:20:00"
        - user_seq: 2
          role_name: USER
          id: dc.jane.doe
          name: Jane Doe
          email: dc.janedoe@directcloud.com
          lang: jpn
          phone: 0987654321
          status: 42
          regdate: "2021-03-29 07:44:50"

UserCreate:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        user_seq:
          type: number
          decription: ユーザー固有番号
          example: 54367

UserRead:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        user_seq:
          type: number
          decription: ユーザー固有番号
          example: 54367
        role_name:
          type: string
          decription: ユーザーロール
          example: USER
        id:
          type: string
          decription: ユーザーID
          example: dc.johndoe
        name:
          type: string
          description: ユーザー名
          example: John Doe
        email:
          type: string
          decription: ユーザーメールアドレス
          example: dc.johndoe@directcloud.com
        lang:
          type: string
          description: ユーザー言語
          example: jpn
        phone:
          type: string
          decription: ユーザーの電話番号
          example: 0123456789
        status:
          type: number
          description: ユーザー登録状態
          example: 11
        volume_size:
          type: number
          description: ユーザーに割り当てる容量(MB)
          example: 31457280
        gmt:
          type: string
          description: ユーザーのGMT
          example: "+9"
        regdate:
          type: string
          description: ユーザー登録日時
          example: "2021-03-29 16:44:50"

GroupList:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    total:
      type: number
      description: 総組織数
      example: 5
    lists:
      type: object
      properties:
        group_seq:
          type: number
          description: 組織固有キー
          example: 300
        parent_group_seq:
          type: number
          description: 組織の親固有キー
          example: 0
        name:
          type: string
          description: 組織名
          example: directcloud
        group_node:
          type: string
          description: 組織のノード
          example: AA
        depth:
          type: number
          description: 組織の所属段階の数値
          example: 0
      example:
        - group_seq: 6345
          parent_group_seq: 0
          name: directcloud
          group_node: AA
          depth: 0
        - group_seq: 6718
          parent_group_seq: 6345
          name: Sales
          group_node: AAAA
          depth: 1
        - group_seq: 6718
          parent_group_seq: 6345
          name: Marketing
          group_node: AAAB
          depth: 1
        - group_seq: 6720
          parent_group_seq: 6345
          name: Finance
          group_node: AAAC
          depth: 1
        - group_seq: 6721
          parent_group_seq: 6345
          name: Operations
          group_node: AAAD
          depth: 1

GroupCreate:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        group_seq:
          type: number
          description: グループ番号
          example: 98765

GroupRead:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        group_path:
          type: string
          decription: 検索した組織の経路情報
          example: "/directcloud/Sales"
        name:
          type: string
          description: 組織の名
          example: Sales

RelationList:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    total:
      type: number
      description: 総組織とユーザー関係数
      example: 2
    lists:
      type: array
      description: リストの詳細
      items:
        type: object
        properties:
          group_user_info_seq:
            type: number
            description: 関係の固有キー
          group_seq:
            type: number
            description: 組織の固有キー
          group_path:
            type: string
            description: 関係が結ばれた組織の所属情報
      example:
        - group_user_info_seq: 81818
          group_seq: 6345
          group_path: "/directcloud/"
        - group_user_info_seq: 81836
          group_seq: 6721
          group_path: "/directcloud/Operations/"

RelationCreate:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        group_user_info_seq:
          type: number
          description: 関係の固有キー
          example: 81836

SharedBoxList:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    total:
      type: number
      description: 総使用者数
      example: 6
    lists:
      type: object
      description: 共有ボックスフォルダリスト
      properties:
        name:
          type: string
          decription: フォルダ名
        node:
          type: string
          decription: フォルダーのノード
        url:
          type: string
          description: ウェブアドレス
        drive_path:
          type: string
          description: ドライブパス
      example:
        - name: Clients
          node: "1{2000"
          url: "https://web.directcloud.jp/sharedbox/MXsyVkdIVmZM"
          drive_path: "/共有/!!!test/Clients"
        - name: References
          node: "1{2001"
          url: "https://web.directcloud.jp/sharedbox/MXsyVkdIcGJY"
          drive_path: "/共有/!!!test/References"
        - name: Projects
          node: "1{2002"
          url: "https://web.directcloud.jp/sharedbox/MXsyVkdIeWlO"
          drive_path: "/共有/!!!test/Projects"
        - name: Pitch
          node: "1{2003"
          url: "https://web.directcloud.jp/sharedbox/MXsyDddIVmZA"
          drive_path: "/共有/!!!test/Pitch"
        - name: Team
          node: "1{2004"
          url: "https://web.directcloud.jp/sharedbox/MXsyVedIfmZM"
          drive_path: "/共有/!!!test/Team"
        - name: Engineer
          node: "1{2005"
          url: "https://web.directcloud.jp/sharedbox/MXsyVkdIVmGa"
          drive_path: "/共有/!!!test/Engineer"

SharedBoxRead:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    result:
      type: object
      description: 結果データ
      properties:
        name:
          type: string
          description: フォルダ名
          example: DirectCloud
        path:
          type: string
          description: フォルダーの経路
          example: "/Shared Box/DirectCloud"
        url:
          type: string
          description: ウェブアドレス
          example: "https://web.directcloud.jp/sharedbox/MXsyVkdIVmGa/"
        drive_path:
          type: string
          description: ドライブパス
          example: "/共有/!!!test/DirectCloud"

SSOInit:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    idp_name:
      type: string
      description: idP
      example: "Microsoft"
    key:
      type: string
      description: 認証キー
      example: "VGVABCTi1rZmF4MS02ODU1Nw=="

SSOStatus:
  properties:
    success:
      type: boolean
      description: API処理結果
      example: true
    status:
      type: string
      description: 状態コード
      example: "2"
    access_token:
      type: string
      description: ユーザー検証のためのアクセストークン
      example: 123456a7b8c9d0f1e1234f567ghi89ij0kl1m2n34o5p6789q0rs1234t56u7v8
    expire:
      type: string
      description: access_token満了する日付時間
      example: "2021-04-04 14:05:48"
    expire_timestamp:
      type: number
      description: access_token満了されるUNIX TIMESTAMP
      example: 1617545148
    user_id:
      type: string
      description: 유저 아이디
      example: string

PermissionList:
  description: 共有ボックスフォルダの権限一覧
  example: {
    "success": true,
    "result": {
      "groups": [
        {
          "dir_permission_seq": 43814,
          "group_seq": 6718,
          "name": "Sales",
          "permission_name": "editor"
        },
      ],
      "users": [
        {
          "dir_permission_seq": 42814,
          "user_seq": 1,
          "id": "dc.john",
          "name": "John Doe",
          "permission_name": "owner"
        },
        {
          "dir_permission_seq": 42815,
          "user_seq": 2,
          "id": "dc.jane",
          "name": "Jane Doe",
          "permission_name": "uploader"
        },
      ],
      "guests": [],
      "groups_count": 1,
      "users_count": 2,
      "guests_count": 0
    }
  }
